import type { ParsedField } from '@/types/field';

// String-typed fields that hold currency values. The schema types them as
// string but the user-facing semantic is dollars, so they should be presented
// and edited like other currency fields.
export const CURRENCY_FIELD_NAMES = new Set<string>(['lineTotalLayerLimit', 'quotaShareTotal']);

export const isCurrencyField = (field: ParsedField | undefined): boolean => {
  if (!field) return false;
  if (field.type === 'number') return true;
  return CURRENCY_FIELD_NAMES.has(field.name);
};
